import styled, { css } from "styled-components";

export const MainFeaturesContainer = styled.div(
  ({ theme: { colors } }) => css`
    position: relative;
    padding: 1rem;
  `
);
